import { render, staticRenderFns } from "./railwayBookingBasic.vue?vue&type=template&id=0e2925fd&scoped=true&"
import script from "./railwayBookingBasic.vue?vue&type=script&lang=js&"
export * from "./railwayBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./railwayBookingBasic.vue?vue&type=style&index=0&id=0e2925fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2925fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2925fd')) {
      api.createRecord('0e2925fd', component.options)
    } else {
      api.reload('0e2925fd', component.options)
    }
    module.hot.accept("./railwayBookingBasic.vue?vue&type=template&id=0e2925fd&scoped=true&", function () {
      api.rerender('0e2925fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/railwayBookingBasic.vue"
export default component.exports